import * as React from "react";
import IconTextBar, { IIconTextBarProps } from "~/components/icon-text-bar/icon-text-bar";

export interface IIconTextBarViewProps {
    contextModel: IIconTextBarProps;
}

class IconTextBarView extends React.PureComponent<IIconTextBarViewProps> {
    public render() {
        return <IconTextBar {...this.props.contextModel} />;
    }
}

export default IconTextBarView;
